// Shared constants and assets for homepage components
export const COLORS = {
  primary: '#F5F3EF',
  secondary: '#D9D9D6',
  text: '#2F2F2F',
  accent: '#C97A2B',
  terracotta: '#B65A3A',
  olive: '#6B705C',
  dark: '#1A1A1A',
};

export const FRAME_IMAGE = "https://customer-assets.emergentagent.com/job_55f4b5e7-2baa-4587-a5f6-01a3193241e9/artifacts/jqm98u1k_images%20%282%29.jpeg";
